
import CountUp from 'react-countup';

const subTitle = "COMMENCEZ VERS LE SUCCÈS";
const title = "Atteignez vos objectifs avec COTRACALL";


const achievementList = [
    {
        count: '30',
        desc: 'Années d\'expérience dans l\'enseignement des langues',
    },
    {
        count: '3084',
        desc: 'Apprenants inscrits aux formations COTRACALL',
    },
    {
        count: '330',
        desc: 'Enseignants qualifiés et experts linguistiques',
    },
    {
        count: '2300',
        desc: 'Cours de langues étrangères innovants',
    },
]

const AchievementTwo = () => {
    return (
        <div className="achievement-section padding-tb">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="counter-part mb-4">
                        <div className="row g-4 row-cols-lg-4 row-cols-sm-2 row-cols-1 justify-content-center">
                            {achievementList.map((val, i) => (
                                <div className="col" key={i}>
                                    <div className="count-item">
                                        <div className="count-inner">
                                            <div className="count-content">
                                                <h2><span className="count"><CountUp end={val.count} /></span><span>+</span></h2>
                                                <p>{val.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default AchievementTwo;